import SelectorWrapper from "src/components/selectorwrapper/SelectorWrapper";
import OptionsProps from "src/components/streaming/findsomethingtostream/OptionsProps";
import { SFilterBlock, SLabelledCheck, SScrollContainer } from "src/components/streaming/findsomethingtostream/OptionsStyles";
import styled from "src/lib/styles/css";


//#region [Component]
export default function OptionsFilmOrSeries({ filterDispatch, filterState }: OptionsProps) {
	return <SelectorWrapper onClose={() => filterDispatch({ type: "hideOptions" })}>
		<SScrollContainer>
			<SFilterBlockOptionsFilmOrSeries>
				<SLabelledCheck selected={!filterState.moviesOnly && !filterState.seriesOnly}
					value="Alle"
					selectionCallback={() => filterDispatch({ type: 'setFilmOrSeriesShowAll' })}
				/>

				<SLabelledCheck selected={filterState.moviesOnly}
					value="Film"
					selectionCallback={() => filterDispatch({ type: 'setMoviesOnly' })}
				/>

				<SLabelledCheck selected={filterState.seriesOnly}
					value="Serie"
					selectionCallback={() => filterDispatch({ type: 'setSeriesOnly' })}
				/>
			</SFilterBlockOptionsFilmOrSeries>
		</SScrollContainer>
	</SelectorWrapper>;
}
//#endregion

//#region [Styles]
const SFilterBlockOptionsFilmOrSeries = styled(SFilterBlock)`
	justify-content: center;
`;
//#endregion